<template lang="pug">
    section
        Meta(:title-placeholder="title")
</template>

<script>
import { useSetupStore, usePageStore } from '@/stores'
import Meta from '@/components/Page/Meta';

export default {
    name: 'PageMeta',
    components: {
        Meta,
    },
    computed: {
        pageStore() {
            return usePageStore();
        },
        title() {
            return _.get(this.form, 'title', '')
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        form() {
            return this.pageStore.form;
        },
        options() {
            return this.pageStore.options;
        },
    },
}
</script>

<style lang="sass" scoped></style>
